//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Hero',
  components: {
    ContributorSignUpLink: () => import('@/components/contributor/signup/ContributorSignUpLink.vue'),
  },
  data() {
    return {
      // heroImg: 'https://static.moele.me/img/signup/contributors/220518/contributors-signup-hero.png',
      // heroImg: 'https://static.moele.me/img/signup/contributors/220624/contributors-signup-hero-220624.png',
    };
  },
  computed: {
    heroImg() {
      if (['ja', 'zh-hant'].includes(this.$i18n.locale)) {
        return 'https://static.moele.me/img/signup/contributors/220624/contributors-signup-hero-ja-220624.png?auto=format&w=761';
      }
      return 'https://static.moele.me/img/signup/contributors/220624/contributors-signup-hero-220624.png?auto=format&w=761';
    },
  },
};
